"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importStar(require("react"));
var swiper_1 = require("swiper");
var Card_1 = __importDefault(require("./Card"));
var PromoTimer_1 = __importDefault(require("./PromoTimer"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
require("./styles.scss");
var react_2 = require("swiper/react");
var Promo = function (_a) {
    var _b, _c;
    var _d = _a.isFullImage, isFullImage = _d === void 0 ? false : _d, _e = _a.showPromoTitle, showPromoTitle = _e === void 0 ? false : _e;
    var slider = (0, react_1.useRef)(null);
    var promotions = (0, swr_hooks_1.usePromotionsByTag)(swr_hooks_1.BonusTag.POSITION_HOME_BLOCK).promotions;
    var _f = (0, react_1.useState)(null), currentPromo = _f[0], setCurrentPromo = _f[1];
    (0, react_1.useEffect)(function () {
        if (!currentPromo) {
            setCurrentPromo(promotions === null || promotions === void 0 ? void 0 : promotions[0]);
        }
    }, [currentPromo, promotions]);
    if (!promotions || promotions.length === 0)
        return null;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " promo-container") },
        react_1.default.createElement(react_2.Swiper, { onBeforeInit: function (swiper) {
                slider.current = swiper;
            }, className: styles_module_scss_1.default.swiper, modules: [swiper_1.Pagination], loop: false, spaceBetween: 0, slidesPerView: 1, pagination: { clickable: true }, autoplay: false, onSlideChange: function (swiper) {
                setCurrentPromo(promotions[swiper.activeIndex]);
            } }, promotions.map(function (promo, idx) {
            var _a;
            return (react_1.default.createElement(react_2.SwiperSlide, { key: "promoOnTheMainPage".concat(idx) },
                react_1.default.createElement(Card_1.default, { promo: promo, imageSrc: ((_a = promo === null || promo === void 0 ? void 0 : promo.images) === null || _a === void 0 ? void 0 : _a.banner) || (0, apps_shared_1.getPromoImageSrc)(promo.slug, 'banner'), isFullImage: isFullImage, showPromoTitle: showPromoTitle })));
        })),
        react_1.default.createElement(PromoTimer_1.default, { startAt: (currentPromo === null || currentPromo === void 0 ? void 0 : currentPromo.dateStart)
                ? String(new Date(currentPromo.dateStart))
                : null, activeDayOfWeek: currentPromo === null || currentPromo === void 0 ? void 0 : currentPromo.activeDayOfWeek, endAt: (currentPromo === null || currentPromo === void 0 ? void 0 : currentPromo.dateEnd) ? String(new Date(currentPromo.dateEnd)) : null, timerType: (currentPromo === null || currentPromo === void 0 ? void 0 : currentPromo.dateStart) ? apps_shared_1.TIMER_TYPE.RANGE : apps_shared_1.TIMER_TYPE.DAY_OF_WEEK }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.navigation },
            promotions.length > 1 && (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.buttonNavigateWrapper, " ").concat(styles_module_scss_1.default.prev, " ").concat(((_b = slider === null || slider === void 0 ? void 0 : slider.current) === null || _b === void 0 ? void 0 : _b.activeIndex) === 0 ? styles_module_scss_1.default.disabled : '') },
                react_1.default.createElement(ui_components_1.NavigateButton, { direction: "prev", onClick: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slidePrev(); } }))),
            promotions.length > 1 && (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.buttonNavigateWrapper, " ").concat(styles_module_scss_1.default.next, " ").concat(((_c = slider === null || slider === void 0 ? void 0 : slider.current) === null || _c === void 0 ? void 0 : _c.activeIndex) < promotions.length - 1
                    ? ''
                    : styles_module_scss_1.default.disabled) },
                react_1.default.createElement(ui_components_1.NavigateButton, { direction: "next", onClick: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slideNext(); } }))))));
};
exports.default = react_1.default.memo(Promo);
